import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import "./MyTable.css";
import { GetPartyDueDetails } from "../../util/APIUtils";
import PartyDueBodyDetails from "./PartyDueBodyDetails";
import { useState } from "react";

const options = {
  sortIndicator: true,
  hideSizePerPage: false,
  paginationSize: 3,
  hidePageListOnlyOnePage: false,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
};

export default function PartyDueBody({
  data,

}) {

  const [filteredParties, setFilteredParties] = useState([]);
  const [block, setBlock] = useState(false);
  const [showPartyDetails, setShowPartyDetails] = useState(false);
  const sum = data.length > 0 ? data.reduce((acc, item) => acc + item.totalDue, 0) : 0;

  const cellButton = (cell, row, enumObject, rowIndex) => {
    return (
      <span>

        <Button
          className="btn btn-warning"
          id={`view-${row.id}`}
          onClick={(e) => getFilteredData(row)}
          style={{ marginLeft: "5px" }}
          key={row.id}
        >
          <i className="fa fa-eye" />
        </Button>

        <UncontrolledTooltip placement="right" target={`view-${row.id}`}>
          View Party Details
        </UncontrolledTooltip>
      </span>
    );
  };


  const getFilteredData = (row) => {
    let obj = {
      partyId: row.partyId
    };
    loadReqData(obj);
  }



  const loadReqData = (obj) => {
    setBlock(true);
    GetPartyDueDetails(obj).then((response) => {
      setFilteredParties(response);
      setBlock(false);
      setShowPartyDetails(true);
    }).catch((error) => {
      swal("Error!", "Error fetching party due details", "error");
      setBlock(false);
    });
  };

  const rowClassNameFormat = (row, rowIdx) => {
    // row is whole row object
    // rowIdx is index of row
    return row.salesPersonName === "Total" ? "tr-odd" : "tr-even";
  };

  return (
    <div>
      <Card>
        <CardHeader className="carheaderSmall">
          {showPartyDetails == false ? (<strong>Payment Due</strong>) : null}
          {showPartyDetails == true ? (<span><strong>Payment Due Details</strong>

            <Button
              className="btn btn-warning"
              onClick={() => setShowPartyDetails(false)}
              style={{ marginRight: "10px", float: "right" }}
            >
              <i className="fa fa-arrow-left" /> Back
            </Button></span>
          ) : null}

        </CardHeader>
        {showPartyDetails == false ? (
          <CardBody>
            <Card color="primary">
              <CardBody>
                <Row>
                  <Col>
                    <CardTitle tag="h4">Total </CardTitle>
                  </Col>
                  <Col>
                    <CardTitle tag="h5">
                      {sum.toFixed(2)}
                    </CardTitle>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <BootstrapTable
              data={data}
              version="4"
              condensed={true}
              striped
              hover
              pagination
              search
              options={options}
              exportCSV
              csvFileName="Party_paymnt_due.csv"
              trClassName={rowClassNameFormat}
            >
              <TableHeaderColumn
                isKey
                dataField="id"
                export={false}
                hidden={true}
              >
                ID
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="partyName"
                csvHeader="Party Name"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
              >
                Party name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="salesPersonName"
                csvHeader=" salesPersonName"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
              >
                Sales Person
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="beatName"
                csvHeader=" beatName"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
              >
                beatName
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="paymentGapDays"
                csvHeader="Payment Gap Days"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
              >
                Payment Gap Days
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="avgBillPaidDays"
                csvHeader="Average Bill Paid Days"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
              >
                Average Bill Paid Days
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="paymentTerm"
                csvHeader="Payment Term"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
              >
                Payment Term
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="totalDue"
                csvHeader="Total Due"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
              >
                Total Due
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="noOfInvoicesPending"
                csvHeader="noOfInvoicesPending"
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
                filter={{
                  type: "NumberFilter",
                  delay: 1000,
                  numberComparators: ["=", ">", "<"],
                }}
              >
                Pending Invoice

              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="button"
                dataFormat={cellButton}
                hiddenOnInsert
                export={false}
              >
                Actions
              </TableHeaderColumn>
            </BootstrapTable>
          </CardBody>) : null}
        {showPartyDetails == true ? (
          <CardBody>
            <PartyDueBodyDetails
              data={filteredParties}
              setShowPartyDetails={setShowPartyDetails}
            />
          </CardBody>
        ) : null}
      </Card>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/PartyDueBody.js